export default __webpack_public_path__ + "static/media/icons8-construction-carpenter-ruler.55a109ac.svg";